// Becasue of the logo.svg import below type import was added
/// <reference types="react-scripts" />
import React from 'react';
import { ReactComponent as Logo } from './logo.svg';
import { Box, Container } from '@mui/material';
import NavMenu from './Nav/NavMenu';
import HamburgerMenu from './Nav/HamburgerMenu';
import AccountItem from './Nav/Account/AccountItem';
import { Link } from 'react-router-dom';
import { useScreenLargerThan } from '../../lib/hooks/breakpoint-hooks';

export type HeaderProps = {
    refObj?: React.MutableRefObject<HTMLDivElement | undefined>;
};

const Header = ({ refObj }: HeaderProps) => {
    const isLargerThanSmall = useScreenLargerThan('sm');
    const isLargerThenLarge = useScreenLargerThan('lg');

    return (
        <Box
            ref={refObj}
            sx={{
                backgroundColor: (t) => t.palette.secondary.main,
                paddingY: '0.625rem',
                borderBottom: 1,
                borderColor: (t) => t.palette.appBackground.main,
                borderBottomWidth: 1
            }}>
            <Container maxWidth="xl">
                {isLargerThenLarge ? (
                    <Box
                        sx={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            gap: 8
                        }}>
                        <Box>
                            <Link to={'/'}>
                                <Logo width="8.375rem" height="2.75rem" />
                            </Link>
                        </Box>
                        <Box
                            sx={{
                                display: 'inline-flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                width: '100%'
                            }}>
                            <NavMenu />
                            <AccountItem />
                        </Box>
                    </Box>
                ) : (
                    <Box
                        sx={{
                            display: 'flex',
                            justifyContent: 'flex-start',
                            alignItems: 'center',
                            gap: 3
                        }}>
                        <HamburgerMenu />
                        <Box
                            sx={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                width: '100%'
                            }}>
                            <Box>
                                <Link to={'/'}>
                                    <Logo width="8.375rem" height="2.75rem" />
                                </Link>
                            </Box>
                            {isLargerThanSmall && <AccountItem />}
                        </Box>
                    </Box>
                )}
            </Container>
        </Box>
    );
};

export default Header;
